module.exports = __webpack_public_path__ + "static/media/dairygold.423bd7f6.png";